
import {
  ProgressBar,
}from 'react-bootstrap';


var React = require('react');
var Radium = require('radium');

class Progress extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      progress: [{}],
    }
  }
  getProgress = () => {
    const {progressList} = this.props;

    //% of each item in bar
    const progressVal = (1 / progressList.length) * 100;

    const corrItems = progressList.filter( x => (x.wasChecked && x.isCorrect)).length;
    const wrongItems = progressList.filter( x => (x.wasChecked && !x.isCorrect)).length;

    let corrVal = progressVal*corrItems;
    let wrongVal = progressVal*wrongItems;

    return(
      <ProgressBar style={styles.progressBar.base}>
        <ProgressBar style={styles.progressBar} bsStyle="success" active now={corrVal} key={1} />
        <ProgressBar style={styles.progressBar} bsStyle="danger" active now={wrongVal} key={2}/>
      </ProgressBar>
    )
  }

  render() {
    return(
      <div>
        <div style={styles.progressBar.title}>
          {"Progress:"}
        </div>
        <div>
        {this.getProgress()}
        </div>
      </div>
    )
  }
}
var styles = {
  progressBar: {
    inner: {
      height: '30px',
    },
    base:{
      marginTop: '5px',
      marginBottom: '3px',
      height: '30px',
    },
    title:{
      color: '#FFFF',
    }
  }
}
//Export and radium wrap
export default Radium(Progress);



// WEBPACK FOOTER //
// ./src/comp/Progress.js